import script from "./GmxEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxEditor.vue?vue&type=script&setup=true&lang=js"

import "./GmxEditor.vue?vue&type=style&index=0&id=5f62f8d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f62f8d4"]])

export default __exports__